module.exports = __webpack_public_path__ + "static/media/IMG_1621.7763a807.JPG";